/**
 * 
 * @returns 
* Title Banner for Website used for announcements and welcoming visitors
*/
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import React from 'react';
import Pdf from '../images/MemoCD.pdf';
import Pdf2 from '../images/254790_Lot_A_Loan_Program_Brochure.pdf';


export default function AwsLoginComponent()
{
    const { user } = useAuthenticator((context) => [context.user]);

    return(
        <div className='whiteFont padding '>               


            {!user && (
            <>
            <h2 className='emphTitle text-center'>
                {user ? `Welcome, ${user.attributes.given_name || ''}` : ''}
            </h2>

            </>
            )}
            <Authenticator className='login_container container' loginMechanisms={['email']} hideSignUp> 
                {/* Authenticator will handle login UI */}
            </Authenticator>
            {user && (
                <div className='whiteFont '>

                    <div className='UserTips'>
                        <ul className='emphBanner loggedInBanner '>
                            <h4 className='text-center emphTitle3'><u>MHB Property Manager Portal Updates</u></h4>
                            <p className='emphTitle2 text-center'><b>LAST UPDATED: 01/01/2026</b></p>
                            <li>
                                <p className='whiteFont'> 
                                    Portal Updated with Payments up to 01/01/2026 in S8, MRVP, and HAPPY Tables.<br></br>
                                </p> 
                            </li>
                            <li className=''>
                                <p className='whiteFont'>
                                    We added a new payments database for WSD checks in September 2025  
                                </p> 
                            </li>
                            <li>
                                <p className='whiteFont'>
                                    Coming Soon: 1099 Document Uploads for 2024<br></br>
                                </p> 
                            </li>
                        </ul>
                        <br></br>
                        <ul className='emphBanner loggedInBanner'>
                            <h4 className='text-center emphTitle3'><u>Announcements</u></h4>
                            <li>    
                                <p>
                                    <a className='btn btn-primary buttons' href={Pdf} target='_blank' rel='noreferrer'>Smoke and Carbon Monoxide Detectors Guidelines - In-Effect since 12/29/24</a>
                                </p> 
                            </li>
                            <li className=''>
                                <p>Newly Added Feature: View WSD Payments. <a className='btn btn-primary buttons' href='/payments'>WSD Payments</a></p>
                            </li>                               
                            <li className='hide'>
                                <p>Newly Aded Feature: Update Direct Deposit Link <a className='btn btn-primary buttons' target='_blank' rel='noreferrer' href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf'>Update Direct Deposit Form</a></p>
                            </li>
                            <li>
                                <p>Loan Program Brochure Update:  <a className='btn btn-primary buttons' target='_blank' rel='noreferrer' href={Pdf2} >254790_Lot_A_Loan_Program_Brochure</a></p>
                            </li>
                        </ul> 
                    </div>
                </div>
            )}
            <br></br>
            <br></br>


            
        </div>

    );
}